import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/styles/main.scss';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import HomeScreen from './Screens/public/HomeScreen';
// Comentado para evitar que se cargue la pantalla de citas
// import CitaScreen from './Screens/public/CitaScreen';
import MasajesScreen from './Screens/public/MasajesScreen';
import ContactoScreen from './Screens/public/ContactoScreen';
import EditorScreen from './Screens/admin/EditorScreen';
import AvisoLegalScreen from './Screens/public/AvisoLegalScreen';
import PoliticaPrivacidadScreen from './Screens/public/PoliticaPrivacidadScreen';
import ProteccionDatosScreen from './Screens/public/ProteccionDatosScreen';


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} >
      <Route index element={<HomeScreen />} />
      
      {/* Ruta de cita comentada para desactivarla por completo y que devuelva un 404 */}
      {/* <Route path="cita" element={<CitaScreen />} /> */}
      
      <Route path="masajes" element={<MasajesScreen />} />
      <Route path="contacto" element={<ContactoScreen />} />
      <Route path="editor" element={<EditorScreen />} />
      <Route path="aviso-legal" element={<AvisoLegalScreen />} />
      <Route path="*" element={<h1>404 Not Found</h1>} />
      <Route path="politica-privacidad" element={<PoliticaPrivacidadScreen />} />
      <Route path="proteccion-datos" element={<ProteccionDatosScreen />} />
    </Route>
  )
);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();